<template>
  <div>
    <div>
      <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
      <h3 class="mt-3">
        {{
          $getVisibleNames(
            "mesh.certification",
            false,
            "Certificación de Credenciales"
          )
        }}
        <AlternativeNameButton
          :table_name="'mesh.certification'"
          :allows_crud="allows_crud"
        ></AlternativeNameButton>
      </h3>
      <div style="display: flex">
        <div class="col" style="text-align: left">
          <ButtonMedium
            v-can="'mesh.add_certification'"
            v-if="allows_crud"
            :tooltip_text="
              $t('reusable.common.addTooltip', {
                entity: $getVisibleNames(
                  'mesh.certification',
                  false,
                  'Certificación de Credenciales'
                ),
              })
            "
            :text_button="$t('reusable.common.add')"
            :click_button="() => $bvModal.show(`new-certification-modal`)"
            :icon="'plus'"
            :variant="'primary'"
          >
          </ButtonMedium>
        </div>
      </div>
      <GenericBTable
        :items="certifications"
        :fields="certificationsFields"
        :filter="input_search"
        :filterCustom="filterCustom"
        @emitChangeSearchField="changeInputSearch"
        :show_pagination="true"
        :search_filter="true"
        :columns_display="true"
        :allows_crud="allows_crud"
        :display_id="display_id"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
      >
        <template #cell(matters)="row">
          <div class="campus-container">
            <div
              v-for="item in getMatterName(row.item.matters)"
              :key="item.id"
              class="kl-chip"
            >
              {{ item.name }}
            </div>
          </div>
        </template>
        <template #cell(egress_profile)="row">
          {{ getEgressProfile(row.item.egress_profile) }}
        </template>
        <template v-if="allows_crud" #cell(actions)="row">
          <ButtonSmall
            v-can="'mesh.change_certification'"
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'mesh.certification',
                  false,
                  'Certificación de Credenciales'
                ),
              })
            "
            :click_button="
              () => $bvModal.show(`edit-certification-modal-${row.item.id}`)
            "
            :class="``"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-can="'mesh.delete_certification'"
            :click_button="() => askForDeleteCertification(row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames(
                  'mesh.certification',
                  false,
                  'Certificación de Credenciales'
                ),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <b-modal
            :id="`edit-certification-modal-${row.item.id}`"
            :title="
              $t('reusable.common.editModalTitle', {
                entity: $getVisibleNames(
                  'mesh.certification',
                  false,
                  'Certificación de Credenciales'
                ),
              })
            "
            size="lg"
            hide-footer
          >
            <CertificationForm
              :Certification="row.item"
              @updated="slotUpdatedCertification"
              :show_title="false"
            ></CertificationForm>
          </b-modal>
        </template>
        <template #cell(description)="row">
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </template>
      </GenericBTable>
    </div>
    <b-modal
      :id="`new-certification-modal`"
      :hide-footer="true"
      :title="
        $t('reusable.common.createModalTitle', {
          entity: $getVisibleNames(
            'mesh.certification',
            false,
            'Certificación de Credenciales'
          ),
        })
      "
      size="lg"
    >
      <CertificationForm
        @created="slotCreatedCertification"
      ></CertificationForm>
    </b-modal>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";

export default {
  name: "CertificationView",
  components: {
    CertificationForm: () =>
      import(
        "@/components/mesh/CurricularResources/Certification/CertificationForm"
      ),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    AlternativeNameButton: () =>
      import("@/components/reusable/AlternativeNameButton"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    display_id: {},
  },
  data() {
    return {
      sortBy: "",
      input_search: "",
      sortDesc: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      matters: names.MATTERS,
      certifications: names.CERTIFICATIONS,
      egress_profiles: names.EGRESS_PROFILES,
    }),
    breadcrumb_items() {
      return [
        {
          text: this.$t("reusable.breadcrumb.home"),
          to: "/home",
        },
        {
          text: this.$getVisibleNames(
            "mesh.certification",
            false,
            "Certificación de Credenciales"
          ),
        },
      ];
    },
    allows_crud() {
      const has_permission = this.$hasPermissions("mesh.add_certification");
      if (
        has_permission &&
        this.user &&
        (this.user.group_names.includes(
          "DIRECTIVOS ACADÉMICOS INSTITUCIONALES"
        ) ||
          this.user.is_superuser)
      )
        return has_permission;
      else return false;
    },
    certificationsFields() {
      if (!this.allows_crud)
        return this.certifications_fields.filter(
          (field) => !field.requires_allows_crud
        );
      else return this.certifications_fields;
    },
    certifications_fields() {
      return [
        {
          key: "name",
          label: String(
            this.$getVisibleNames(
              "mesh.certification",
              true,
              "Certificaciones de Credenciales"
            )
          ),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "description",
          label: String(this.$t("reusable.common.description")),
          sortable: true,
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "egress_profile",
          label: String(
            this.$getVisibleNames(
              "mesh.egressprofile",
              false,
              "Perfil de egreso"
            )
          ),
          sortable: true,
          // La celda muestra el nombre del perfil de egreso, no su id
          sortByFormatted: (value, key, item) =>
            this.getEgressProfile(item.egress_profile),
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "matters",
          label: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ),
          sortable: true,
          // La celda muestra los nombres de las asignaturas, no sus ids
          sortByFormatted: (value, key, item) =>
            this.getMatterName(item.matters)
              .map((x) => x.name)
              .join(", "),
          tdClass: "text-left",
          display_column: true,
        },
        {
          key: "actions",
          label: "",
          display_column: true,
          thClass: "noprint",
          tdClass: "noprint",
        },
      ];
    },
  },
  methods: {
    filterCustom(row) {
      if (
        this.$filtered(String(row.name), this.input_search) ||
        this.$filtered(String(row.description), this.input_search) ||
        this.$filtered(
          this.getEgressProfile(row.egress_profile),
          this.input_search
        )
      ) {
        return true;
      } else {
        false;
      }
    },
    changeInputSearch(input_search) {
      this.input_search = input_search;
    },
    getEgressProfile(id) {
      let egress_profile = this.egress_profiles.find((x) => x.id == id);
      return egress_profile ? egress_profile.name : "";
    },
    getMatterName(matters) {
      if (matters.length > 0) {
        const list = this.matters.filter((element) =>
          matters.includes(element.id)
        );
        return list.sort((a, b) => {
          if (a.name > b.name) return 1;
          if (a.name < b.name) return -1;
          return 0;
        });
      } else return [];
    },
    askForDeleteCertification(certification_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "mesh.certification",
            false,
            "Certificación de Credenciales"
          ),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_CERTIFICATION, certification_id)
            .then(() => {
              toast(
                String(
                  this.$getVisibleNames(
                    "mesh.certification",
                    false,
                    "Certificación de Credenciales"
                  ) +
                    " " +
                    this.$t("reusable.common.deleted")
                )
              );
            });
        }
      });
    },
    slotCreatedCertification() {
      this.$bvModal.hide("new-certification-modal");
    },
    slotUpdatedCertification(certification) {
      this.$bvModal.hide(`edit-certification-modal-${certification.id}`);
    },
    fetchCertifications() {
      // force: true porque esta vista necesita SIEMPRE el listado completo
      // de la institución. Sin esto, si el usuario visitó antes la malla
      // curricular (que ahora pide certificaciones filtradas por perfil de
      // egreso), el caché del store quedaría parcial y esta vista lo daría
      // por completo sin volver a pedirlo.
      this.$store
        .dispatch(names.FETCH_CERTIFICATIONS, { force: true })
        .then((response) => {
          const matters_ids = [
            ...new Set(response.flatMap((cert) => cert.matters || [])),
          ];
          const egress_profiles_ids = [
            ...new Set(
              response
                .filter((cert) => cert.egress_profile)
                .map((cert) => cert.egress_profile)
            ),
          ];
          this.$store.dispatch(names.FETCH_EGRESS_PROFILES, {
            egress_profile_ids: egress_profiles_ids,
          });

          if (matters_ids.length > 0) {
            this.$store.dispatch(names.FETCH_MATTERS, {
              matter_ids: matters_ids,
            });
          }
        });
    },
  },
  mounted() {},
  created() {
    this.fetchCertifications();
  },
};
</script>

<style scoped>
th {
  background-color: var(--primary-color);
  border-radius: 6px;
  box-shadow: 1px 1px 3px rgb(72, 72, 72);
}

.title-header {
  padding: 0;
  margin-top: auto;
}
.search-certification {
  max-width: 50rem;
  margin-left: auto;
  margin-right: 18.5%;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
.edit-section {
  margin-top: -2%;
}
.campus-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
}
</style>